'use strict';
import React, { PureComponent } from 'react';
import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import Titulo from './Titulo';
import SeccionFiltros from './SeccionFiltros/SeccionFiltros';
import SeccionGrilla from './SeccionGrilla/SeccionGrilla';

/* MODALES */
import ModalNuevoAsiento from './Modales/ModalNuevoAsiento/ModalNuevoAsiento';
import ModalDetalleAsiento from './Modales/ModalDetalleAsiento/ModalDetalleAsiento';
import ModalConfirmarDetalleAsiento from './Modales/ModalConfirmarDetalleAsiento/ModalConfirmarDetalleAsiento';
import ModalSeleccionModelos from './Modales/ModalSeleccionModelos/ModalSeleccionModelos';
import ModalConfirmarEliminacionModelos from './Modales/ModalConfirmarEliminacionModelos/ModalConfirmarEliminacionModelos';
import ModalConfirmarBajaAsientos from './Modales/ModalConfirmarBajaAsientos/ModalConfirmarBajaAsientos';

class AsientosContables extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            primeraConsultaRealizada: false
        };
    }

    componentDidMount() {
        this.props.actions.obtenerInformacionPantalla(this.props.currentScope, this.props.executionContext);
    }

    componentWillUnmount() {
        this.props.actions.resetState();
    }

    handleConsultaRealizada = () => {
        this.setState({ primeraConsultaRealizada: true });
    };

    render() {
        const { actions, data } = this.props;
        const {
            primeraCargaPantalla,
            permisosUsuario,
            mostrarSpinner,
            errorValidacion
        } = this.props.data;

        const error = {
            message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
            linkMessage: "Volver a mi pagina de inicio"
        };

        const { primeraConsultaRealizada } = this.state;

        const errorPermisoConsulta = <GenericErrorScreen data={error} />;

        const componente = permisosUsuario.Consulta ?
            <div>
                {mostrarSpinner && <div id="loading" className="loading" />}

                {(!data.modalDetalleAsiento && !data.modalNuevoAsiento) && 
                <div>
                    <Titulo 
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        permisoAlta={permisosUsuario.Alta}
                    /> 

                    <div className="AsientosContables__lineaDivisoria"></div>

                    <SeccionFiltros
                        handleConsultaRealizada={this.handleConsultaRealizada}
                        cambiarCheckAsientosContables={actions.cambiarCheckAsientosContables}
                        cambiarValorInput={actions.cambiarValorInput}
                        cargarInformacionBtnVer={actions.cargarInformacionBtnVer}
                        desplegarFiltros={actions.desplegarFiltros}
                        guardarQuitarModeloSeleccionado={actions.guardarQuitarModeloSeleccionado}
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        ocultarBotonVerMas={actions.ocultarBotonVerMas}
                        seleccionarOpcionCombo={actions.seleccionarOpcionCombo}
                        validarInputFecha={actions.validarInputFecha}
                    
                        checkFechaContabilizacion={data.checksAsientosContables.checkFechaContabilizacion}
                        checkFechaRendicion={data.checksAsientosContables.checkFechaRendicion}
                        checkFechaValor={data.checksAsientosContables.checkFechaValor}
                        checkSoloConfirmadosManualmente={data.checksAsientosContables.checkSoloConfirmadosManualmente}
                        checkSoloDadosBaja={data.checksAsientosContables.checkSoloDadosBaja}
                        checkSoloIngresadosModificadosManualmente={data.checksAsientosContables.checkSoloIngresadosModificadosManualmente}
                        checkSoloNoBalanceados={data.checksAsientosContables.checkSoloNoBalanceados}
                        comboEstado={data.combosAsientosContables.comboEstado}
                        comboMarca={data.combosAsientosContables.comboMarca}
                        comboMoneda={data.combosAsientosContables.comboMoneda}
                        comboSucursal={data.combosAsientosContables.comboSucursal}
                        datosEstados={data.combosFiltrosAdicionales.datosEstados}
                        datosMonedas={data.combosFiltrosAdicionales.datosMonedas}
                        datosSucursales={data.combosFiltrosAdicionales.datosSucursales}
                        errorValidacion={errorValidacion}
                        estaDesplegado={data.estaDesplegado}
                        inputFechaContabilizacionDesde={data.inputsAsientosContables.inputFechaContabilizacionDesde}
                        inputFechaContabilizacionHasta={data.inputsAsientosContables.inputFechaContabilizacionHasta}
                        inputFechaRendicionDesde={data.inputsAsientosContables.inputFechaRendicionDesde}
                        inputFechaRendicionHasta={data.inputsAsientosContables.inputFechaRendicionHasta}
                        inputFechaValorDesde={data.inputsAsientosContables.inputFechaValorDesde}
                        inputFechaValorHasta={data.inputsAsientosContables.inputFechaValorHasta}
                        inputIdAsiento={data.inputsAsientosContables.inputIdAsiento}
                        marcasActivas={data.marcasActivas}
                        modelosContablesSeleccionados={data.inputsAsientosContables.modalSeleccionModelos.modelosContablesSeleccionados}
                        mostrarVerMas={data.mostrarVerMas}
                        primeraCargaPantalla={primeraCargaPantalla}
                        todosModelosSeleccionados={data.checksAsientosContables.modalSeleccionModelos.checkTodosModelos}                    
                    /> 

                    <div className="AsientosContables__lineaDivisoria"></div>

                    
                    <SeccionGrilla 
                        primeraConsultaRealizada={primeraConsultaRealizada}
                        desplegarDatosAdicionales={actions.desplegarDatosAdicionales}
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        obtenerDatosDetalleAsiento={actions.obtenerDatosDetalleAsiento}
                        cargarInformacionReproceso={actions.cargarInformacionReproceso}
                        seleccionarOpcionCombo={actions.seleccionarOpcionCombo}
                        tildarDestildarTodosAsientosContables={actions.tildarDestildarTodosAsientosContables}
                        cambiarCheckAsientosContables={actions.cambiarCheckAsientosContables}
                        cambiarCheckRegistroResultadoBusqueda={actions.cambiarCheckRegistroResultadoBusqueda}
                        validarAplicarAccionMasiva={actions.validarAplicarAccionMasiva}
                        mostrarOcultarSpinner={actions.mostrarOcultarSpinner}

                        comboAccionMasiva={data.combosAsientosContables.comboAccionMasiva}
                        estadosAsientos={data.estadosAsientos}
                        arrayResultadoBusquedaAsientos={data.arrayResultadoBusquedaAsientos}
                        registroDesplegado={data.registroDesplegado}
                        permisosUsuario={data.permisosUsuario}
                        checksAsientosContables={data.checksAsientosContables}
                        checkTodosAsientosContables={data.checksAsientosContables.checkTodosAsientosContables}
                        setearOrigenLlamadoModalConfirmacionBaja={actions.setearOrigenLlamadoModalConfirmacionBaja}
                    />
              </div> }

                {data.modalNuevoAsiento &&
                    <ModalNuevoAsiento 
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        reiniciarCamposModalNuevoAsiento={actions.reiniciarCamposModalNuevoAsiento}
                        fechaActual={data.fechaActual}
                        selectorFechaNuevoAsiento={data.propsModalNuevoAsiento.selectorFechaNuevoAsiento}
                        modelosManuales={data.propsModalNuevoAsiento.modelosManuales}
                        registrosManuales={data.propsModalNuevoAsiento.renglonesAgregadosManualmente}
                        renglonesManualesFiltrados={data.propsModalNuevoAsiento.renglonesManualesFiltrados}
                        centrosCosto={data.propsModalNuevoAsiento.centrosCosto}
                        comentarios={data.propsModalNuevoAsiento.comentarios}
                        cuentasContables={data.propsModalNuevoAsiento.cuentasContablesFiltradas}
                        inputActivo={data.propsModalNuevoAsiento.inputActivo}
                        inputCuentaContable={data.inputsAsientosContables.propsModalNuevoAsiento.inputCuentaContable}
                        actualizarComentarios={actions.actualizarComentarios}
                        agregarRenglonManual={actions.agregarRenglonManual}
                        modificarRenglonManual={actions.modificarRenglonManual}
                        buscarCuentasContables={actions.buscarCuentasContables}
                        cargarRenglonesManualesFiltradosDelModelo={actions.cargarRenglonesManualesFiltradosDelModelo}
                        cambiarValorInput={actions.cambiarValorInput}
                        cambiarInputActivo={actions.cambiarInputActivo}
                        detallesModeloElegido={data.detallesModeloElegido}
                        detalleRenglonDatosDesplegados = {data.propsModalNuevoAsiento.detalleRenglonDatosDesplegados}
                        usuarioLogin={data.usuarioLogin}
                        monedasAsiento={data.combosFiltrosAdicionales.datosMonedas}
                        cambiarOpcionCombo={actions.cambiarOpcionCombo}
                        desplegarDatosDetalleRenglonNuevoAsiento={actions.desplegarDatosDetalleRenglon}
                        validarSelectorFecha={actions.validarSelectorFecha}
                        obtenerDetallesModelo={actions.obtenerDetallesModelo}
                        guardarActualizarAsientoContable={actions.guardarActualizarAsientoContable}
                        comboModeloNuevoAsiento={data.combosAsientosContables.comboModeloNuevoAsiento}
                        
                    />
                }
                

                {data.modalConfirmarDetalleAsiento &&
                    <ModalConfirmarDetalleAsiento 
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        descargarExcel={actions.descargarExcel}
                    /> }

                
                {data.modalAsientosContables.registroDetalle && data.modalDetalleAsiento && !mostrarSpinner && 
                    <ModalDetalleAsiento 
                        desplegarDatosDetalleAsiento={actions.desplegarDatosDetalleAsiento}
                        guardarActualizarAsientoContable={actions.guardarActualizarAsientoContable}
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        buscarCuentasContables={actions.buscarCuentasContables}
                        cambiarValorInput={actions.cambiarValorInput}
                        cambiarInputActivo={actions.cambiarInputActivo}
                        agregarRenglonManual={actions.agregarRenglonManual}
                        modificarRenglonManual={actions.modificarRenglonManual}
                        limpiarModalAsientosContables={actions.limpiarModalAsientosContables}
                        cargarRenglonesManualesFiltradosDelModelo={actions.cargarRenglonesManualesFiltradosDelModelo}
                        descargaTipoMovimiento={actions.descargaTipoMovimiento}
                        renglonesAgregadosManualmente={data.modalAsientosContables.renglonesAgregadosManualmente}
                        registro={data.modalAsientosContables.registroDetalle}
                        renglonesManualesFiltrados={data.modalAsientosContables.renglonesManualesFiltrados}
                        comboEstadosAsientos = {data.comboEstadosAsientos}
                        permisosUsuario={data.permisosUsuario}
                        centrosCosto={data.modalAsientosContables.centrosCosto}
                        monedasAsiento={data.combosFiltrosAdicionales.datosMonedas}
                        registroDatosReproceso={data.modalAsientosContables.registroDatosReproceso} 
                        renglonesContablesAsiento={data.modalAsientosContables.renglonesContablesAsiento}
                        renglonesAsientoIdentificados={data.modalAsientosContables.renglonesAsientoIdentificados}
                        renglonesContablesModelo={data.modalAsientosContables.renglonesContablesModelo}
                        cuentasContables={data.modalAsientosContables.cuentasContables}
                        inputActivo={data.modalAsientosContables.inputActivo}
                        inputBuscadorCuentaContable={data.inputsAsientosContables.modalAsientosContables.inputCuentaContable}
                        detalleAsientoDatosDesplegados = {data.modalAsientosContables.detalleAsientoDatosDesplegados}
                        detalleRenglonDatosDesplegados = {data.modalAsientosContables.detalleRenglonDatosDesplegados}
                        desplegarDatosDetalleRenglon = {actions.desplegarDatosDetalleRenglon}
                        datosExcelAsientosContables = {data.datosExcelAsientosContables}
                        armarDatosExportacionExcel={actions.armarDatosExportacionExcel}
                        descargarExcel={actions.descargarExcel}
                        cambiarEstadoAsiento={actions.cambiarEstadoAsiento}
                        setearOrigenLlamadoModalConfirmacionBaja={actions.setearOrigenLlamadoModalConfirmacionBaja}
                    /> }


                {data.modalSeleccionModelos &&
                    <ModalSeleccionModelos
                        buscarModelosContables={actions.buscarModelosContables}
                        cambiarCheckAsientosContables={actions.cambiarCheckAsientosContables}
                        guardarQuitarModeloSeleccionado={actions.guardarQuitarModeloSeleccionado}
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}

                        checkTodosModelos={data.checksAsientosContables.modalSeleccionModelos.checkTodosModelos}
                        inputBuscadorModelos={data.inputsAsientosContables.modalSeleccionModelos.inputBuscadorModelos}
                        modelosContablesFiltrados={data.inputsAsientosContables.modalSeleccionModelos.modelosContablesFiltrados}
                        modelosContablesSeleccionados={data.inputsAsientosContables.modalSeleccionModelos.modelosContablesSeleccionados}
                    /> }

                {data.modalConfirmarEliminacionModelos &&
                    <ModalConfirmarEliminacionModelos
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        limpiarModelosSeleccionados={actions.limpiarModelosSeleccionados}
                        valorComboMarcaTemporal={data.valorComboMarcaTemporal}
                    />}

                {data.modalConfirmarBajaAsientos ?
                    <ModalConfirmarBajaAsientos
                        mostrarOcultarModalAsientosContables={actions.mostrarOcultarModalAsientosContables}
                        validarAplicarAccionMasiva={actions.validarAplicarAccionMasiva}
                        esModalDetalleAsiento= {data.origenLlamadoModalBaja == "modalDetalleAsiento"}
                        esAccionMasiva={data.origenLlamadoModalBaja == "accionMasiva"}
                        guardarActualizarAsientoContable={actions.guardarActualizarAsientoContable}
                        desplegarDatosDetalleAsiento={actions.desplegarDatosDetalleAsiento}
                        cambiarValorInput={actions.cambiarValorInput}
                        cambiarInputActivo={actions.cambiarInputActivo}
                        limpiarModalAsientosContables={actions.limpiarModalAsientosContables}
                        setearOrigenLlamadoModalConfirmacionBaja={actions.setearOrigenLlamadoModalConfirmacionBaja}
                    />
                :
                    null
                }

            </div>
        :
            errorPermisoConsulta;

        return (
            <div> 
                {/* Se genera esta variable "primeraCargaPantalla" para que, cuando se ingrese por primera vez a la pantalla de Modelos Contables,
                    no se visualice el mensaje de permisos por un instante antes de cargar la grilla posteriormente (en caso de que tenga efectivamente permisos de consulta minimamente)*/}
                {primeraCargaPantalla ?
                    null
                :
                    componente
                }
            </div>
        );
    }
}

export default AsientosContables;